import PropTypes from 'prop-types';
import { AlloyButton } from 'cat-ecommerce-alloy';

const CallToAction = ({ title, onClick }) => (
  <AlloyButton
    className="px-0"
    buttonType="ghost"
    title={title}
    onClick={onClick}
    size="dynamic"
  >
    {title}
  </AlloyButton>
);
CallToAction.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func
};

export default CallToAction;
